import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { ImageIcon } from '../../../BaseComponents/Image/Components'
import DurationLabel from '../../../BaseComponents/Labels/Duration'
import Image from '../../../BaseComponents/Image'

type Props = {
    imageUrl?: string
    alt?: string
    videoDuration?: string
}

const VideoRecommendationTeaserImage = ({ imageUrl, alt, videoDuration }: Props): ReactElement => {
    return (
        <Grid noExpand width={203} position="relative">
            <Image size="M" imageUrl={imageUrl} alt={alt} width="100%" radiusType="rounded" />
            <ImageIcon type="video" size="XS" />
            {videoDuration ? (
                <Grid
                    zIndex={5}
                    position="absolute"
                    width="100%"
                    height="100%"
                    alignRight
                    alignBottom
                >
                    <Grid noExpand margin={4}>
                        <DurationLabel duration={videoDuration} />
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    )
}

export default VideoRecommendationTeaserImage
